module.exports = __webpack_public_path__ + "img/exhibit-intro-small.9bec92e8.png";